import * as cmpstub from '@iabtechlabtcf/stub';

cmpstub();

import {
    TCString, 
    TCModel,
    GVL
} from '@iabtechlabtcf/core';
import {
    CmpApi
} from '@iabtechlabtcf/cmpapi';
import WebFont from 'webfontloader';


import '../../scss/style.scss';

window.openConsentWindow = function () {
    TVPtcfapi.openConsentWindow()
};

window.switchDarkMode = function () {
    TVPtcfapi.darkMode = !TVPtcfapi.darkMode
    TVPtcfapi.switchDarkMode()
};

window.loadOverlay = function () {
    TVPtcfapi.init()
}; 
window.isCmpOpen = function () {
    return TVPtcfapi.isOpen()
};
const PROXY_URL = "https://polityka-prywatnosci.tvp.pl";
GVL.baseUrl = PROXY_URL + "/shared/"; 
GVL.latestFilename = "consent_api.php?consent=getPublicVendorList&consentApiVersion=v2";

const gvl = new GVL("LATEST");

Array.prototype.remove = function () {
    var what, a = arguments,
        L = a.length,
        ax;
    while (L && this.length) {
        what = a[--L];
        while ((ax = this.indexOf(what)) !== -1) {
            this.splice(ax, 1);
        }
    }
    return this;
};


var TVPtcfapi = {
    cmpID: 351,
    cmpVersion: 3,
    cmpOpenEvent: null,
    cmpCloseEvent: null, 
    consentApiVersion: 'v2',
    defaultApplicationId: 1, 
    basicUser: null,
    basicPasswd: null,    
    applicationId: document.currentScript.getAttribute("applicationid") ? parseInt(document.currentScript.getAttribute("applicationid")) : 1,
    darkMode: document.currentScript.getAttribute("dark") == 'true',
    uiLang: document.currentScript.getAttribute("lang") ? document.currentScript.getAttribute("lang") : 'pl',
    abcMod: document.currentScript.getAttribute("abc") == 'true',
    cookieName: 'TVPtcs22',
    newGVLVersion: false,    
    urlCookie: PROXY_URL,
    TVPtcfapi: null,
    initialState: false,
    initByButton: false,
    firstTimeScrolled: false,
    publisherPurposesList: [],
    publisherCustomPurposesList: [],
    publisherCustomPurposes: [],
    legitInPurposes: [],
    init: async function () {
        const gvlVersion = await TVPtcfapi.checkGVLVersion()
        this.cmpCloseEvent = new Event('cmp_close');
        this.cmpOpenEvent = new Event('cmp_open');
        await TVPtcfapi.initAPI(gvlVersion)
    },
    initAPI: async function (gvlVersion) {
        TVPtcfapi.cmpApi = new CmpApi(TVPtcfapi.cmpID, TVPtcfapi.cmpVersion, true);

        const encodedTCString = TVPtcfapi.getCookie(TVPtcfapi.cookieName)

        await TVPtcfapi.getPublisherPurposesList()

        TVPtcfapi.getPublisherCustomPurposes()

        if (encodedTCString === '' || gvlVersion) {
            // puste cookie pobierz zgody
            TVPtcfapi.cmpApi.update('', true);

            await gvl.readyPromise
            TVPtcfapi.tcModel = new TCModel(gvl);
            TVPtcfapi.setAllVendorLegitimateInterests();
            TVPtcfapi.checkLegitInPurposes();
            TVPtcfapi.setAllIABLegitimateInterests();

            TVPtcfapi.initTCString();
            if (TVPtcfapi.initialState) TVPtcfapi.setAll();

            await TVPtcfapi.loadOverlay()
            TVPtcfapi.loadFonts()
            window.dispatchEvent(TVPtcfapi.cmpOpenEvent);
            TVPtcfapi.toggleLockOnBodyAndHTML();

        } else {
            TVPtcfapi.cmpApi.update(encodedTCString, false);
            TVPtcfapi.tcModel = TCString.decode(encodedTCString);
            TVPtcfapi.checkScriptsForPlace();
            await gvl.readyPromise.then()
            TVPtcfapi.tcModel.gvl = gvl;
            TVPtcfapi.checkLegitInPurposes();
        }

    },
    getPublisherCustomPurposes() {
        let customFromCookie = TVPtcfapi.getCookie(this.cookieName + 'custom')
        if (customFromCookie) {
            TVPtcfapi.publisherCustomPurposes = JSON.parse(customFromCookie)
        }
    },
    showNonEmpty() {
        const items = document.querySelectorAll('.tvp-covl__container')
        if (items.length) {
            items.forEach(item => {
                const itm = item.querySelector('.tvp-covl__items')
                if (itm && itm.children.length) item.classList.add('show');
            })
        }
    },
    initLoader: function () {
        let img = document.createElement("img");
        img.classList.add('loader');
        img.src = `${TVPtcfapi.urlCookie}/files/portale-v4/polityka-prywatnosci/gfx/loader.svg`;
        let tco = document.querySelector('.tvp-covl');
        if (tco) tco.appendChild(img);
    },
    showLoader: function () {
        let loader = document.querySelector('.loader');
        if (loader) loader.classList.add('show')
        else {
            TVPtcfapi.initLoader()
            loader = document.querySelector('.loader');
            if (loader) loader.classList.add('show')
        }
    },
    toggleLockOnBodyAndHTML() {
        if (!document.body.classList.contains("tvp-cookie-scroll-lock"))
            document.body.classList.add("tvp-cookie-scroll-lock");
        else
            document.body.classList.remove("tvp-cookie-scroll-lock");
        if (!document.querySelector("html").classList.contains("tvp-cookie-scroll-lock"))
            document.querySelector("html").classList.add("tvp-cookie-scroll-lock");
        else
            document.querySelector("html").classList.remove("tvp-cookie-scroll-lock");
    },
    hideLoader: function () {
        let loader = document.querySelector('.loader');
        if (loader) loader.classList.remove('show')
    },
    initTCString: function () {

        TVPtcfapi.tcModel.cmpVersion = TVPtcfapi.cmpVersion;
        TVPtcfapi.tcModel.cmpId = TVPtcfapi.cmpID;
        TVPtcfapi.tcModel.publisherCountryCode = "PL";
        TVPtcfapi.tcModel.consentLanguage = "PL";
        TVPtcfapi.tcModel.isServiceSpecific = true;

    },
    setAllSpecialFeatureOptIns() {
        for (let key in TVPtcfapi.tcModel.gvl_.specialFeatures) {
            TVPtcfapi.tcModel.specialFeatureOptins.set(TVPtcfapi.tcModel.gvl_.specialFeatures[key].id);
        }
    },
    setAllVendorLegitimateInterests() {
        for (let key in TVPtcfapi.tcModel.gvl_.vendors) {
            TVPtcfapi.tcModel.vendorLegitimateInterests.set(TVPtcfapi.tcModel.gvl_.vendors[key].id);
        }
    },
    checkIsAllIABLegitmateInterestIsEmpty() {
        return TVPtcfapi.tcModel.purposeLegitimateInterests.size == 0;
    },
    setAllIABLegitimateInterests() {
        for (let key in TVPtcfapi.tcModel.gvl_.purposes) {
            if (TVPtcfapi.legitInPurposes.indexOf(TVPtcfapi.tcModel.gvl_.purposes[key].id) > -1)
                TVPtcfapi.tcModel.purposeLegitimateInterests.set(TVPtcfapi.tcModel.gvl_.purposes[key].id);
        }
        let btns = document.querySelectorAll('.switch-input[data-type="spli"][data-source="1"]');
        Array.from(btns).forEach(btn => {
            btn.checked = true;
        });

    },
    unsetAllIABLegitimateInterests() {
        for (let key in TVPtcfapi.tcModel.gvl_.purposes) {
            TVPtcfapi.tcModel.purposeLegitimateInterests.unset(TVPtcfapi.tcModel.gvl_.purposes[key].id);
        }
        let btns = document.querySelectorAll('.switch-input[data-type="spli"][data-source="1"]');
        Array.from(btns).forEach(btn => {
            btn.checked = false;
        });
    },
    unsetAllVendorLegitimateInterests() {
        for (let key in TVPtcfapi.tcModel.gvl_.vendors) {
            TVPtcfapi.tcModel.vendorLegitimateInterests.unset(TVPtcfapi.tcModel.gvl_.vendors[key].id);
        }
    },
    setAll() {
        TVPtcfapi.setAllPublisherConsents()
        TVPtcfapi.setAllSpecialFeatureOptIns()
        TVPtcfapi.tcModel.setAllVendorConsents()
        TVPtcfapi.setAllVendorLegitimateInterests()
        TVPtcfapi.setAllIABLegitimateInterests()
        TVPtcfapi.tcModel.setAllPurposeConsents()
    },
    acceptAll() {
        TVPtcfapi.setAll()
        TVPtcfapi.saveTCString()
    },
    saveTCString: function () {
        const tcs = TVPtcfapi.encodeTCString()
        TVPtcfapi.tcModel["specialFeatureOptins"].set(1);
        TVPtcfapi.setCookie(TVPtcfapi.cookieName, tcs, 365)
        TVPtcfapi.setCookie(TVPtcfapi.cookieName + 'custom', JSON.stringify(TVPtcfapi.publisherCustomPurposes), 365)
        TVPtcfapi.setCookie(TVPtcfapi.cookieName + 'ver', TVPtcfapi.tcModel.gvl_.vendorListVersion, 365)
        TVPtcfapi.saveToAPI(tcs)
        TVPtcfapi.cmpApi.update(tcs, false);
        TVPtcfapi.closeOverlay()
    },
    closeOverlay() {
        let cookieOverlayMain = document.querySelector('.tvp-cookie-overlay');
        cookieOverlayMain.parentNode.removeChild(cookieOverlayMain)
        window.dispatchEvent(TVPtcfapi.cmpCloseEvent);
        TVPtcfapi.toggleLockOnBodyAndHTML();
        TVPtcfapi.initByButton = false;
    },
    encodeTCString() {
        this.tcModel.numCustomPurposes_ = TVPtcfapi.publisherPurposesList.length;
        const encodedTCString = TCString.encode(TVPtcfapi.tcModel);
        return encodedTCString
    },
    ajaxCall: function (url, auth, post, addLang = true) {
        return new Promise((resolve, reject) => {
            const req = window.XMLHttpRequest ?
                new XMLHttpRequest() :
                new ActiveXObject('Microsoft.XMLHTTP');

            req.addEventListener("load", e => {
                resolve(req.responseText);
            });
            req.addEventListener("error", e => {
                reject(req.statusText);
            });

            let delim="&";
            if(!url.includes("?")) delim="?";
            if(TVPtcfapi.consentApiVersion) url += delim + "consentApiVersion=" + TVPtcfapi.consentApiVersion

            if (TVPtcfapi.uiLang != 'pl' && addLang) {
                if (typeof addLang != "boolean") {
                    url = url + `&lang=${addLang}`;
                }
                else {
                    url = url + `&lang=${TVPtcfapi.uiLang}`;
                }

            }            

            if (post != null) {
                req.open('POST', url);
                if (auth != '') { 
                    req.setRequestHeader('Authorization', `Bearer ${auth}`)
                }
                req.setRequestHeader("Content-Type", "application/json;charset=utf-8");
                req.send(JSON.stringify(post));
            } else {
                req.open('GET', url, true, TVPtcfapi.basicUser, TVPtcfapi.basicPasswd);
                if(TVPtcfapi.basicPasswd) req.withCredentials = true;
                if (auth != '') {                    
                    req.setRequestHeader('Authorization', `Bearer ${auth}`);
                    
                }
                req.send();
            }
        })
    },
    loadVendorsList: async function (e) {
        TVPtcfapi.showLoader()
        const uid = parseInt(e.target.dataset.uid)
        const type = e.target.dataset.type;
        const sourceId = e.target.dataset.source;
        let res = ""
        if (sourceId != 3) {
            res = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?applicationUid=${TVPtcfapi.defaultApplicationId}&consent=getVendorsWith${type}&template=consents22/vendors.html&sourceUid=${sourceId}&itemUids[]=${uid}`, '', null, false)
        }
        else {
            res = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?applicationUid=${TVPtcfapi.defaultApplicationId}&consent=getVendorsWith${type}&template=consents22/vendors-no-redirect.html&sourceUid=${sourceId}&itemUids[]=${uid}`, '', null, false)
        }

        e.target.parentElement.querySelector(".vendors").innerHTML = res;
        let ul = e.target.parentElement.querySelector(".vendors ul")
        let count = ""
        if (ul) count = ul.dataset.count
        e.target.parentElement.querySelector(".vendors-button .count").innerHTML = `(${count} firm)`;

        TVPtcfapi.bindButtons(".vendor-details", (e) => {
            TVPtcfapi.loadVendors(e.target.dataset.id)
            return false;
        }, e.target.parentElement.querySelector(".vendors"))

        TVPtcfapi.hideLoader()
    },
    Base64EncodeUrl(str) {
        return str.replace(/\+/g, '-').replace(/\//g, '_').replace(/\=+$/, '');
    },
    getPublisherPurposesList: async function () {
        let res = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?consent=getTvpConsentDetails&enabled=1`, '', null)
        if (res) {
            TVPtcfapi.publisherPurposesList = []
            let data = JSON.parse(res)
            if ('purposes' in data && Array.isArray(data.purposes)) {
                data = data.purposes
                data.forEach(item => {
                    TVPtcfapi.publisherPurposesList.push(item.uid);
                })
            }
        }

        res = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?consent=getPurposes&enabled=1&sourceUid=3`, '', null, TVPtcfapi.uiLang == 'en' ? 'eng' : 'pl')
        if (res) {
            TVPtcfapi.publisherCustomPurposesList = []
            let data = JSON.parse(res)
            if (data) {
                data.forEach(item => {
                    TVPtcfapi.publisherCustomPurposesList.push(item.uid);
                })
            }
        }

    },
    getVendorsCount: async function (sourceUid) {
        let res = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?sourceUid=${sourceUid}&consent=getVendors`, '', null)
        res = JSON.parse(res)
        return res.length
    },
    reloadOverlay: async function () {
        const covl = document.querySelector('.tvp-cookie-overlay');
        covl.remove();
        TVPtcfapi.loadOverlay()
    },
    checkScriptsForPlace: async function () {
        const url = TVPtcfapi.Base64EncodeUrl(btoa(window.location.href.split('#')[0]));

        const script = document.createElement('script');
        const cpl = TVPtcfapi.publisherCustomPurposes.join(', ')
        script.src = `${TVPtcfapi.urlCookie}/shared/consent_api.php?vendorUids[]=[${cpl}]&consent=getScript&executionPlace=${url}`;

        document.head.appendChild(script);

    },
    saveToAPI: async function (tcs) {
        const b = document.getElementById('ip');

        var date = new Date();


        const tvpModel = {
            "createdAt": date.toISOString(),
            "userIp": b.dataset.ip,
            "userAgent": navigator.userAgent,
            "consentString": tcs,
            "applicationUId": TVPtcfapi.applicationId,
            "isEnabled": true,
            "purposeUids": TVPtcfapi.publisherCustomPurposes
        }
        const token = await TVPtcfapi.ajaxCall('/sess/consent_generatetoken.php', '', null);
        await TVPtcfapi.ajaxCall('/sess/consent_saveuserconsent.php', token, tvpModel)

    },
    showDataRetention: function (place, data) {

        let dr = place.querySelector(".data-retention")

        dr.classList.remove('hide');

        if (TVPtcfapi.uiLang == 'en') dr.innerHTML = "Maximum data storage retention (days): <strong>" + Math.ceil(data/86400) + "</strong>"
        else dr.innerHTML = "Maksymalny okres przechowywania cookies (dni): <strong>" + Math.ceil(data/86400) + "</strong>"
    },
    showUrls: function (place, data) {
        let pl = place.querySelector(".policies")

        let pp = place.querySelector(".privacy-policy")
        let li = place.querySelector(".legitimate-interests")

        pl.classList.remove('hide');

        pp.innerHTML = data.privacy
        pp.href = data.privacy
        li.innerHTML = data.legIntClaim
        li.href = data.legIntClaim
    },
    listItems: function (type, place, data, vId, det = false) {
        if (!place) return;
        const vendors = TVPtcfapi.tcModel.gvl.vendors;
        let vendor = vendors[vId];
        let dataType = "purposes";
        switch (type) {
            case "features":
                dataType = "features";
                break;
            case "special-features":
                dataType = "specialFeatures";
                break;
            case "legitimate-interest-purposes":
                dataType = "legIntPurposes";
                break;
            case "special-purposes":
                dataType = "specialPurposes";
                break;
            case "data-categories":
                dataType = "dataDeclaration";
                break;
            default:
                dataType = "purposes";
        }
        if (vendor[dataType].length > 0) {
            place.classList.remove('hide');
        }
        const ul = place.querySelector('.list')
        while (ul.lastElementChild) {
            ul.removeChild(ul.lastElementChild);
        }
        let days = "Okres przechowywania (dni): "
        if (TVPtcfapi.uiLang == 'en') days = "Storage time (days): "
        for (let item in data) {
            if (vendor[dataType].indexOf(data[item].uid) > -1) {
                var li = document.createElement('li');
                let dr = ""
                if (det && det[0]) {
                    if (Object.keys(det[0].dataRetention).indexOf(dataType) != -1 && det[0].dataRetention[dataType][parseInt(data[item].uid)]) {
                        dr = " <strong>" + days + det[0].dataRetention[dataType][parseInt(data[item].uid)] + "</strong>"
                    }
                    else {
                        dr = " <strong>" + days + (det[0].dataRetention.stdRetention == 0 ? "<1 dzień" : det[0].dataRetention.stdRetention) + "</strong>"
                    }
                }
                if (TVPtcfapi.uiLang == 'en') li.innerHTML = data[item].nameEn + dr
                else li.innerHTML = data[item].name + dr
                if (li.innerHTML) ul.appendChild(li);
            }
        }
    },
    loadModal: function (title, body, cbckyes, cbckno) {

        const ovl = document.querySelector('.tvp-covl');

        ovl.classList.add('tvp-covl__modal');
        ovl.innerHTML = `<div class="tvp-covl__i"><h3>${title}</h3><p>${body}</p></div><div class="tvp-covl__b"><div class="tvp-covl__yes">Tak</div><div class="tvp-covl__no">Nie</div></div>`;

        TVPtcfapi.bindButton('.tvp-covl__yes', () => {
            cbckyes()
            return false;
        })
        TVPtcfapi.bindButton('.tvp-covl__no', () => {
            cbckno()
            return false;
        })
    },
    loadOverlay: async function () {
        const res = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?applicationUid=${TVPtcfapi.defaultApplicationId}&consent=getTemplate&template=consents22/first-screen.html`, '', null)
        const body = document.querySelector('body');
        const ovl = document.createElement('div');
        const dim = document.createElement('div');

        ovl.classList.add('tvp-cookie-overlay');
        ovl.innerHTML = res;

        if (TVPtcfapi.abcMod) dim.classList.add('tvp-cookie-abcdim');

        ovl.appendChild(dim);
        body.appendChild(ovl);

        const cookieOverlay = document.querySelector('.tvp-covl');
        if (cookieOverlay == null) return

        const cw = document.querySelector('.tvp-covl__ra')
        if (cw && TVPtcfapi.initByButton) cw.classList.add("show")

        TVPtcfapi.addFirmCount()

        if (TVPtcfapi.darkMode) {
            if (cookieOverlay != null)
                cookieOverlay.classList.add('dark');
            TVPtcfapi.switchDarkMode()
        }

        TVPtcfapi.bindButton('.tvp-covl__sb', () => {
            TVPtcfapi.loadAdvanced();
            return false;
        })

        TVPtcfapi.bindButton('.tvp-covl__ra', () => {
            TVPtcfapi.loadModal(
                "Czy chcesz wycofać wszystkie zgody?",
                "Wszystkie twoje zgody na stronach TVP zostaną wycofane. Czy na pewno chcesz wycofać zgody?",
                TVPtcfapi.removeConsents,
                TVPtcfapi.reloadOverlay
            )
            return false;
        })

        TVPtcfapi.bindButtons('.tvp-covl__sblink', () => {
            TVPtcfapi.loadAdvanced();
            return false;
        })

        TVPtcfapi.bindButton('.tvp-covl__ab', () => {
            TVPtcfapi.acceptAll();
            return false;
        })

        TVPtcfapi.bindButtons('.tvp-covl__showvendorslink', () => {
            TVPtcfapi.loadVendors();
            return false;
        })
        cookieOverlay.style.display = 'block';
    },
    addFirmCount: async function () {
        const ciab = await TVPtcfapi.getVendorsCount(1)
        const cother = await TVPtcfapi.getVendorsCount(3)

        const svl = document.querySelector('.tvp-covl__showvendorslink')
        const tpl = document.querySelector('.tvp-covl__tvppartnerslink')
        
        if(svl) svl.innerHTML += ` (${ciab} firm)`
        if(tpl) tpl.innerHTML += ` (${cother} firm)`        
    },
    loadVendors: async function (scrollToId = null) {
        TVPtcfapi.showLoader()
        const ovl = document.querySelector('.tvp-covl');
        const loader = document.createElement('div');
        ovl.appendChild(loader);
        const res = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?applicationUid=${TVPtcfapi.defaultApplicationId}&consent=getTemplate&template=consents22/vendors-list.html`, '', null)
        const cont = document.createElement('div');
        ovl.classList.add('tvp-covl__big');
        cont.classList.add('tvp-covl__content');
        cont.innerHTML = res;
        ovl.innerHTML = '';
        ovl.appendChild(cont);
        TVPtcfapi.deleteNotActiveVendors();
        TVPtcfapi.deleteNotValidVendorsSwitch();
        TVPtcfapi.deleteNotValidIABInterestSwitch();
        TVPtcfapi.deleteNotValidVendorsInterestSwitch();
        TVPtcfapi.bindCheckboxes();
        TVPtcfapi.bindIABDisableCheckbox();
        TVPtcfapi.setUIStateFromTcString()

        TVPtcfapi.bindButtons('.desc-box-button', async (e) => {
            TVPtcfapi.ajaxVendorDetails(e.target)
            return false;
        })

        TVPtcfapi.bindButton('.tvp-covl__backc', () => {
            TVPtcfapi.loadAdvanced()
            return false;
        })

        TVPtcfapi.bindButton('.tvp-covl__save', () => {
            TVPtcfapi.saveTCString()
            return false;
        })

        TVPtcfapi.bindButton('.tvp-covl__ab', () => {
            TVPtcfapi.acceptAll()
            return false;
        })

        TVPtcfapi.showNonEmpty()
        TVPtcfapi.hideLoader()

        const obox = document.querySelector(".vendor-box-" + scrollToId)
        if (obox) TVPtcfapi.ajaxVendorDetails(obox)

        const cv = document.getElementById("vendor-" + scrollToId);
        if (cv) cv.scrollIntoView();

    },
    loadAdvanced: async function () {
        TVPtcfapi.showLoader()
        const res = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?applicationUid=${TVPtcfapi.defaultApplicationId}&consent=getTemplate&template=consents22/consents.html`, '', null)

        const ovl = document.querySelector('.tvp-covl');

        const cont = document.createElement('div');
        ovl.classList.add('tvp-covl__big');
        if (TVPtcfapi.darkMode) {
            ovl.classList.add('dark');
            TVPtcfapi.switchDarkMode()
        }
        cont.classList.add('tvp-covl__content');
        cont.innerHTML = res;
        ovl.innerHTML = '';
        ovl.appendChild(cont);
        TVPtcfapi.deleteNotActiveVendors();
        TVPtcfapi.deleteNotValidVendorsSwitch();
        TVPtcfapi.deleteNotValidIABInterestSwitch();
        TVPtcfapi.deleteNotValidVendorsInterestSwitch();
        TVPtcfapi.bindCheckboxes()
        TVPtcfapi.bindIABDisableCheckbox();
        TVPtcfapi.setUIStateFromTcString()

        TVPtcfapi.bindButton('.tvp-covl__backc', () => {
            TVPtcfapi.reloadOverlay()
            return false;
        })

        TVPtcfapi.bindButtons('.vendors-button', async (e) => {

            let btn = e.target.parentElement.querySelector(".vendors")
            if (btn) btn.classList.toggle('open')

            if (btn && btn.classList.contains('open'))
                await TVPtcfapi.loadVendorsList(e)

            return false;
        })

        TVPtcfapi.bindButtons('.desc-box-button', (e) => {

            e.target.closest(".desc-box-button").classList.toggle('active')
            e.target.closest(".box").querySelector(".desc-box").classList.toggle('open')

            return false;
        })

        TVPtcfapi.bindButton('.tvp-covl__save', () => {
            TVPtcfapi.saveTCString()
            return false;
        })

        TVPtcfapi.bindButton('.tvp-covl__ab', () => {

            TVPtcfapi.acceptAll()
            return false;
        })

        TVPtcfapi.bindButton('.tvp-covl__showvendors', () => {
            TVPtcfapi.loadVendors();
            return false;
        })

        TVPtcfapi.bindButtons('.tvp-covl__showvendorslink', () => {
            TVPtcfapi.loadVendors();
            return false;
        })

        TVPtcfapi.showNonEmpty()
        TVPtcfapi.hideLoader()

    },
    async checkGVLVersion() {
        const res = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?consent=getPublicVendorListVersion`, '', null)
        if (res) {
            const data = JSON.parse(res)
            return TVPtcfapi.newGVLVersion = data.vendorListVersion !== parseInt(this.getCookie(this.cookieName + 'ver'))
        }
        return false
    },
    switchDarkMode() {
        const ovl = document.querySelector('.tvp-covl');
        if (ovl != null) {
            if (TVPtcfapi.darkMode) ovl.classList.add('dark');
            else ovl.classList.remove('dark')
        }
    },
    loadFonts() {
        WebFont.load({
            google: {
                families: ['Lato:400,700']
            }
        });
    },
    bindButton(cl, func) {
        const btn = document.querySelector(cl);
        if (btn) {
            btn.addEventListener('click', function (e) {
                func()
            });
        }
    },
    bindButtons(cl, func, target = document) {
        let btns = target.querySelectorAll(cl)
        Array.from(btns).forEach(btn => {
            btn.addEventListener('click', function (e) {
                func(e)
            });
        })
    },
    bindInputs(cl, func) {
        let btns = document.querySelectorAll(cl)
        Array.from(btns).forEach(btn => {
            btn.addEventListener('change', function (e) {
                func(e)
            });
        })
    },
    async ajaxVendorDetails(target) {
        const dbb = target.closest(".desc-box-button")
        const b = target.closest(".box")
        dbb.classList.toggle('active')
        b.querySelector(".desc-box").classList.toggle('open')
        const vendorUid = dbb.dataset.id
        let res = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?consent=getVendorDescription&vendorUid=${vendorUid}`, '', null)
        let det = await TVPtcfapi.ajaxCall(`${TVPtcfapi.urlCookie}/shared/consent_api.php?consent=getVendorsDetailed&vendorUid=${vendorUid}`, '', null)
        res = JSON.parse(res)
        det = JSON.parse(det)

        if (det.length > 0 && det[0].cookieMaxAgeSeconds) TVPtcfapi.showDataRetention(b.querySelector(".desc-box"), det[0].cookieMaxAgeSeconds)
        if (res.purposes.length > 0) TVPtcfapi.listItems("purposes", b.querySelector(".purposes"), res.purposes, vendorUid, det)
        if (res.purposes.length > 0) TVPtcfapi.listItems("legitimate-interest-purposes", b.querySelector(".legitimate-interest-purposes"), res.purposes, vendorUid)
        if (res.specialPurposes.length > 0) TVPtcfapi.listItems("special-purposes", b.querySelector(".special-purposes"), res.specialPurposes, vendorUid, det)
        if (res.features.length > 0) TVPtcfapi.listItems("features", b.querySelector(".features"), res.features, vendorUid)
        if (res.specialFeatures.length > 0) TVPtcfapi.listItems("special-features", b.querySelector(".special-features"), res.specialFeatures, vendorUid)
        if (res.dataCategories.length > 0) TVPtcfapi.listItems("data-categories", b.querySelector(".data-categories"), res.dataCategories, vendorUid)
        if (det.length > 0 && det[0].urls.length > 0) TVPtcfapi.showUrls(b.querySelector(".desc-box"), det[0].urls[0])

    },
    deleteNotActiveVendors() {
        let btns = document.querySelectorAll('.switch-input[data-type="vc"][data-source="3"]');
        let vendors = TVPtcfapi.tcModel.gvl.vendors;
        Array.from(btns).forEach(btn => {
            let id = btn.dataset.id;
            if (!vendors[id] || vendors[id].deletedDate) {
                btn.parentNode.parentNode.parentNode.parentNode.removeChild(btn.parentNode.parentNode.parentNode);
                return;
            }
        });
    },
    deleteNotValidVendorsSwitch() {
        let btns = document.querySelectorAll('.switch-input[data-type="vc"][data-source="3"]');
        let vendors = TVPtcfapi.tcModel.gvl.vendors;
        Array.from(btns).forEach(btn => {
            let id = btn.dataset.id;
            if (vendors[id] && vendors[id].purposes.length === 0) {
                if (TVPtcfapi.tcModel.isServiceSpecific) {
                    if (vendors[id].flexiblePurposes.length === 0) {
                        btn.parentNode.parentNode.removeChild(btn.parentNode);
                        return;
                    } else {
                        const restrictions = TVPtcfapi.tcModel.publisherRestrictions.getRestrictions(id);
                        let isValid = false;

                        for (let i = 0, len = restrictions.length; i < len && !isValid; i++) {

                            isValid =
                                (restrictions[i].restrictionType === 1);

                        }

                        if (!isValid) {
                            btn.parentNode.parentNode.removeChild(btn.parentNode);
                            return;
                        }
                    }
                } else {
                    btn.parentNode.parentNode.removeChild(btn.parentNode);
                    return;

                }
            }
        });
    },
    deleteNotValidVendorsInterestSwitch() {
        let btns = document.querySelectorAll('.switch-input[data-type="vli"][data-source="3"]');
        let vendors = TVPtcfapi.tcModel.gvl.vendors;
        Array.from(btns).forEach(btn => {
            let id = btn.dataset.id;
            if (vendors[id] && vendors[id].legIntPurposes.length === 0) {
                btn.parentNode.parentNode.removeChild(btn.parentNode);
            }
        });
    },
    deleteNotValidIABInterestSwitch() {
        let btns = document.querySelectorAll('.switch-input[data-type="spli"][data-source="1"]');
        Array.from(btns).forEach(btn => {
            let id = btn.dataset.id;
            if (TVPtcfapi.legitInPurposes.indexOf(parseInt(id)) == -1) {
                btn.parentNode.parentNode.removeChild(btn.parentNode);
            }
        });
    },
    checkLegitInPurposes() {
        let vendors = TVPtcfapi.tcModel.gvl.vendors;
        Object.entries(vendors).forEach(vendor => {
            TVPtcfapi.legitInPurposes = TVPtcfapi.legitInPurposes.concat(vendor[1].legIntPurposes);
        });
        TVPtcfapi.legitInPurposes = TVPtcfapi.legitInPurposes.filter((item, pos) => TVPtcfapi.legitInPurposes.indexOf(item) === pos);

    },
    checkIABCheckbox() {
        if (document.querySelector('.iabd')) {
            if (TVPtcfapi.checkIsAllIABLegitmateInterestIsEmpty()) {
                document.querySelector('.iabd').checked = true;
            } else {
                document.querySelector('.iabd').checked = false;

            }
        }
    },
    bindIABDisableCheckbox() {
        TVPtcfapi.bindInputs('.iabd', (e) => {
            if (e.target.checked) {
                TVPtcfapi.unsetAllIABLegitimateInterests();
            } else {
                TVPtcfapi.setAllIABLegitimateInterests();
            }
        });
    },
    bindCheckboxes() {
        TVPtcfapi.bindInputs('.switch-input', (e) => {
            let scope = "";
            let subscope = "";
            switch (parseInt(e.target.dataset.source)) {
                case 0:
                    scope = "publisher";
                    break;
                case 1:
                    scope = "purpose";
                    break;
                case 3:
                    scope = "publisherCustom";
                    break;
                default:
                    break;
            }
            switch (e.target.dataset.type) {
                case 'spli':
                    subscope = "LegitimateInterests";
                    break;
                case 'spc':
                    subscope = "Consents";
                    break;
                case 'vli':
                    scope = "";
                    subscope = "vendorLegitimateInterests";
                    break;
                case 'vc':
                    scope = "";
                    subscope = "vendorConsents";
                    break;
                case 'spf':
                    scope = "";
                    subscope = "specialFeatureOptins";
                    break;
                default:
                    break;
            }
            const elmid = parseInt(e.target.dataset.id);
            if (e.target.checked) TVPtcfapi.setConsent(scope, subscope, elmid)
            else TVPtcfapi.unsetConsent(scope, subscope, elmid)
            if (e.target.dataset.type == 'spli')
                TVPtcfapi.checkIABCheckbox();
        })
    },
    setConsent: function (scope, subscope, id) {

        if (scope == 'publisherCustom' && subscope == 'Consents') {
            if (!TVPtcfapi.publisherCustomPurposes.includes(id)) {
                TVPtcfapi.publisherCustomPurposes.push(id)
                if (id < 20000) TVPtcfapi.tcModel[scope + subscope].set(id);
            }
        } else {
            TVPtcfapi.tcModel[scope + subscope].set(id);
        }
    },
    unsetConsent: function (scope, subscope, id) {
        if (scope == 'publisherCustom' && subscope == 'Consents') {
            TVPtcfapi.publisherCustomPurposes.remove(id)
            if (TVPtcfapi.publisherCustomPurposes.includes(id)) {
                TVPtcfapi.publisherCustomPurposes.remove(id)
            }
            if (id < 20000) TVPtcfapi.tcModel[scope + subscope].unset(id);
        } else {
            TVPtcfapi.tcModel[scope + subscope].unset(id);
        }
    },
    isOpen: function () {
        return document.querySelector('.tvp-cookie-overlay') != null;
    },
    openConsentWindow: function () {
        TVPtcfapi.initByButton = true;
        const encodedTCString = TVPtcfapi.getCookie(TVPtcfapi.cookieName)

        TVPtcfapi.cmpApi.update(encodedTCString, true);
        TVPtcfapi.tcModel = TCString.decode(encodedTCString);

        const cookieOverlayBig = document.querySelector('.tvp-covl__big')
        if (cookieOverlayBig) cookieOverlayBig.style.display = 'none';

        gvl.readyPromise.then(() => {
            TVPtcfapi.tcModel.gvl = gvl;
            TVPtcfapi.loadOverlay();
            TVPtcfapi.loadFonts();
            window.dispatchEvent(TVPtcfapi.cmpOpenEvent);
            TVPtcfapi.toggleLockOnBodyAndHTML();
        })

    },
    removeConsents: function () {
        TVPtcfapi.unsetAllPublisherConsents()
        TVPtcfapi.unsetAllIABLegitimateInterests()
        TVPtcfapi.tcModel.unsetAllVendorConsents()
        TVPtcfapi.tcModel.purposeConsents.empty()
        TVPtcfapi.tcModel.specialFeatureOptins.empty()
        TVPtcfapi.saveTCString()
    },
    unsetAllPublisherConsents: function () {
        let inps = document.querySelectorAll('.switch-input')
        TVPtcfapi.publisherPurposesList.forEach(inp => {
            TVPtcfapi.tcModel.publisherConsents.unset(inp)
        })
        TVPtcfapi.publisherCustomPurposesList.forEach(inp => {
            TVPtcfapi.publisherCustomPurposes = []
        })
        TVPtcfapi.publisherPurposesList.forEach(inp => {
            TVPtcfapi.tcModel.publisherCustomConsents.unset(inp)
        })
    },
    setAllPublisherConsents: function () {
        let inps = document.querySelectorAll('.switch-input')
        TVPtcfapi.publisherPurposesList.forEach(inp => {
            TVPtcfapi.tcModel.publisherConsents.set(inp)
        })
        TVPtcfapi.publisherCustomPurposesList.forEach(inp => {
            if (!TVPtcfapi.publisherCustomPurposes.includes(inp)) TVPtcfapi.publisherCustomPurposes.push(inp)
        })
        TVPtcfapi.publisherPurposesList.forEach(inp => {
            TVPtcfapi.tcModel.publisherCustomConsents.set(inp)
        })
    },
    setUIStateFromTcString: function () {
        TVPtcfapi.tcModel.vendorConsents.forEach((hasConsent, id) => {
            const el = document.querySelector('.vc-3-' + parseInt(id))
            if (el) el.checked = hasConsent;
        });
        TVPtcfapi.tcModel.vendorLegitimateInterests.forEach((hasConsent, id) => {
            const el = document.querySelector('.vli-3-' + parseInt(id))
            if (el) el.checked = hasConsent;
        });
        TVPtcfapi.publisherPurposesList.forEach(item => {
            const el = document.querySelector('.spc-0-' + item);
            if (el) el.checked = this.tcModel.publisherConsents.has(item)
        });
        TVPtcfapi.checkIABCheckbox();
        TVPtcfapi.tcModel.purposeConsents.forEach((hasConsent, id) => {
            const el = document.querySelector('.spc-1-' + parseInt(id));
            if (el) el.checked = hasConsent;
        });
        TVPtcfapi.tcModel.purposeLegitimateInterests.forEach((hasConsent, id) => {
            const el = document.querySelector('.spli-1-' + parseInt(id));
            if (el) el.checked = hasConsent;
        });
        TVPtcfapi.publisherCustomPurposesList.forEach(item => {
            const el = document.querySelector('.spc-3-' + item);
            if (el) el.checked = this.publisherCustomPurposes.includes(item)
        });

        TVPtcfapi.tcModel.publisherCustomConsents.forEach((hasConsent, id) => {
            const el = document.querySelector('.spc-3-' + parseInt(id));
            if (el) el.checked = hasConsent;
        });
        TVPtcfapi.tcModel.specialFeatureOptins.forEach((item, key) => {
            const el = document.querySelector('.spf-0-' + key);
            if (el) el.checked = item;
        });
    },
    getCookie: function (cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },
    setCookie: function (name, value, days) {
        var expires = "";
        let domain = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }

        if (window.location.hostname.includes("tvp.pl")) {
            domain = "; Domain=tvp.pl"
        }

        if (window.location.hostname.includes("rctvp.pl")) {
            domain = "; Domain=rctvp.pl"
        }

        document.cookie = name + "=" + (value || "") + expires + "; path=/ " + domain;
    },
    animationFunctions: {
        fadeOut(el) {
            el.style.opacity = 1;

            (function fade() {
                if ((el.style.opacity -= 0.1) < 0) {
                    el.style.display = 'none';
                } else {
                    requestAnimationFrame(fade);
                }
            })();
        },
        fadeIn(el, display) {
            el.style.opacity = 0;
            el.style.display = display || 'block';

            (function fade() {
                let val = parseFloat(el.style.opacity);
                if (!((val += 0.1) > 1)) {
                    el.style.opacity = val;
                    requestAnimationFrame(fade);
                }
            })();
        }
    },
}

if (!TVPtcfapi.abcMod) TVPtcfapi.init()